import callNative from '../callNative';
import isInKwaiying from '../isInKwaiying';
import getAppName from '../getAppName';
import isIphone from '../isIphone';
// webLogger中已经强依赖，无法懒加载
import * as YodaBridges from '@yoda/bridge';
export default async function isAppInstall(scheme, androidAppName) {
    let _scheme = scheme;
    if (scheme.indexOf('://') < 0) {
        _scheme = `${scheme}://`;
    }
    if (isInKwaiying()) {
        const res = await callNative('isAppInstall', {
            params: {
                app: isIphone() ? _scheme : androidAppName,
            },
        });
        return res?.isInstall;
    }
    const app = getAppName();
    if (app === 'kwai') {
        try {
            // @ts-expect-error
            await YodaBridges.invoke('webview.hasInstalledApp', {
                identifier: isIphone() ? _scheme : androidAppName,
            });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    return true;
}
